import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { ReactComponent as LogoZl } from '../../logo.svg';

interface SiteLogoProps {
  /** true = weißes Logo ohne Filter (Hero / dunkle Sections) */
  onDark?: boolean;
  sx?: SxProps<Theme>;
}

const SiteLogo: React.FC<SiteLogoProps> = ({ onDark = true, sx }) => (
  <Box
    sx={{
      width: { xs: 120, md: 200 },
      lineHeight: 0,
      flexShrink: 0,
      ...(!onDark && {
        filter: 'brightness(0) invert(0.35)',
        transition: 'filter 0.35s ease',
      }),
      '& svg': {
        width: '100%',
        height: 'auto',
        display: 'block',
      },
      ...sx,
    }}
  >
    <LogoZl aria-hidden focusable="false" />
  </Box>
);

export default SiteLogo;
